
import { Spain } from "../_Translate/Spain";
import { English } from "../_Translate/English";

export const HAS__FIELDS_RESOURCE_API = false;

const TRANSLATE = { es: Spain, en: English };

export const onFieldsContent = (lang = "es") => (TRANSLATE[lang] ?? Spain).FIELDS;

export const FIELDS_CONTENT = onFieldsContent();
